// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-page {\n    padding: 10px;\n}\n\n.message-bars {\n    margin-bottom: 5px;\n}\n\n.message-bar-show {\n    display: block;\n}\n\n.message-bar-hide {\n    display: none;\n}\n\n.connect-button {\n    margin: 10px auto;\n    text-align: center; /* Edge */\n    width: fit-content;\n}\n\n", ""]);
// Exports
module.exports = exports;
